import { getRecoil } from "recoil-nexus";
import roomDetailState from "../../atoms/roomDetail";
import { socket } from "../index";

const emitGiftBullet = (
  quantity: number,
) => {
  const roomDetail = getRecoil(roomDetailState);

  socket?.emit('GIFT_BULLET', { 
    roomId: roomDetail.id,
    receiverId: roomDetail.owner,
    quantity,
  });
}

export default emitGiftBullet;